
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/zoomMode/components/SectionsDropZoneContainer/SectionsDropZoneContainer.scss.css.virtualfile';
        module.exports = {"container":"_container_f4pcx_1"};